import angular from 'angular';
import { MeurhApontamentosService } from './apontamentos.service';

export const MeurhApontamentosListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhApontamentosService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhApontamentosService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        nsjGlobals: any
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['apontamento']) {
                        return $q<void>(() => $state.go('apontamentos_apontamentos'));
                    }

                    return entityService.get($rootScope.nsjGlobals.a.estabelecimento, $stateParams['apontamento'])
                        .then((data) => {
                            const deveRedirecionar = data.estabelecimento.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                            if (deveRedirecionar) {
                                return $q(() => $state.go('apontamentos_apontamentos'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('apontamentos_apontamentos_not_found', $stateParams)) {
                                        $state.go('apontamentos_apontamentos_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
            }]
        };

        $stateProvider
            .state('apontamentos_apontamentos', {
                url: '/movimentos/registrargrupo?q?mesreferencia?anoreferencia?situacao?tipo',
                template: require('html-loader!./index/apontamentos.index.html'),
                controller: 'MeurhApontamentosIndexController',
                controllerAs: 'pntmnts_pntmnts_lst_cntrllr'
            })
            .state('apontamentos_apontamentos_new', {
                parent: 'apontamentos_apontamentos',
                url: '/new',
                template: require('html-loader!./new/apontamentos.new.html'),
                controller: 'MeurhApontamentosNewController',
                controllerAs: 'pntmnts_pntmnts_frm_nw_cntrllr'
            })
            .state('apontamentos_apontamentos_edit', {
                parent: 'apontamentos_apontamentos',
                url: '/:apontamento/edit',
                resolve,
                template: require('html-loader!./edit/apontamentos.edit.html'),
                controller: 'MeurhApontamentosEditController',
                controllerAs: 'pntmnts_pntmnts_frm_cntrllr',
                reloadOnSearch: false
            });
    }
];
